import { alkymetricsClient } from '../alkymetricsClient';

export const getWorkspaceUsageStatistics = async (
  workspaceId,
  startDate = null,
  endDate = null
) => {
  try {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;

    const { data } = await alkymetricsClient.get(`/workspace/${workspaceId}/usage-statistics`, {
      params,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
